module.exports = __webpack_public_path__ + "static/media/fb.056cdeab.svg";